import { CustomerAPI } from 'api'

export const fetchGeolocation = () => {
    return CustomerAPI.get('/location')
}